export default __webpack_public_path__ + "static/media/Axa.04c36b77.jpeg";